var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"cursor-pointer",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('img',{staticClass:"w-4 inline-block",attrs:{"src":"/images/icons/information.webp"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }